import React, { PureComponent } from 'react';

import { InjectedIntl, injectIntl } from 'react-intl';

import CrossIcon from '@atlaskit/icon/glyph/cross';
import SearchIcon from '@atlaskit/icon/glyph/search';
import Textfield from '@atlaskit/textfield';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
/* eslint frontbucket-patterns/no-old-tooltip: "warn" */
import Tooltip from '@atlaskit/tooltip';

import { srOnlyStyles } from 'src/components/accessibility';
import messages from 'src/i18n/common';

import * as styles from './search-field.style';

export type Props = {
  currentSearch: string | null | undefined;
  handleFilterChange: (e: React.FormEvent<HTMLInputElement>) => void;
  intl: InjectedIntl;
  placeholder?: string;
  clearFilter?: () => void;
  fieldName?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  forwardedRef?: (
    el: React.InputHTMLAttributes<HTMLInputElement> | null | undefined
  ) => void;
  elemBeforeInput?: React.ReactNode;
  width?: string;
  isDisabled?: boolean;
  tooltipContent?: string;
};

export class SearchField extends PureComponent<Props> {
  render() {
    const {
      currentSearch,
      handleFilterChange,
      placeholder,
      clearFilter,
      fieldName,
      intl,
      onFocus,
      onBlur,
      forwardedRef,
      elemBeforeInput,
      width,
      isDisabled,
      tooltipContent,
    } = this.props;

    const textField = (
      <Textfield
        autoComplete="off"
        name={fieldName}
        id={fieldName}
        value={currentSearch || ''}
        onChange={handleFilterChange}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        isDisabled={isDisabled}
        ref={forwardedRef}
        elemBeforeInput={elemBeforeInput}
        elemAfterInput={
          clearFilter &&
          (currentSearch ? (
            <styles.ClearFilterButton
              aria-label={intl.formatMessage(messages.clearFilter)}
              appearance="subtle"
              spacing="none"
              onClick={clearFilter}
              iconAfter={<CrossIcon label="" size="small" />}
            />
          ) : (
            <styles.SearchIconWrapper>
              <SearchIcon
                label=""
                size="small"
                primaryColor={token('color.icon', colors.N500)}
              />
            </styles.SearchIconWrapper>
          ))
        }
      />
    );

    return (
      <styles.SearchFieldWrapper role="search" width={width}>
        <label className={srOnlyStyles} htmlFor={fieldName}>
          {placeholder}
        </label>
        {tooltipContent ? (
          <Tooltip content={tooltipContent} position="top">
            {textField}
          </Tooltip>
        ) : (
          textField
        )}
      </styles.SearchFieldWrapper>
    );
  }
}

export default injectIntl(SearchField);
